// extracted by mini-css-extract-plugin
export default {"shipmentsContainer":"truckPreparationForm_shipmentsContainer__WpjO6","separator":"truckPreparationForm_separator__CTmPA"};